import { FieldType, SeoType } from '@/lib/StrapiGqlHelpers';

export const BackgroundFields = {
  BackgroundOrbs: FieldType.Text,
  BackgroundOrbsOverflow: FieldType.Boolean,
  BackgroundColor: FieldType.Text,
  ContainedBackground: FieldType.Boolean,
  FadeInOutContent: FieldType.Boolean,
  AnimateOrbs: FieldType.Boolean,
};

export const DisplayOptions = {
  PaddingTop: FieldType.Text,
  PaddingBottom: FieldType.Text,
  PaddingInline: FieldType.Text,
  CenterAlignTitles: FieldType.Boolean,
  CenterAlignParagraphs: FieldType.Boolean,
  CenterAlignImages: FieldType.Boolean,
  ContentsWidth: FieldType.Text,
};

export const AuthorFields = {
  Name: FieldType.Text,
  Title: FieldType.Text,
  Role: FieldType.Text,
  Bio: FieldType.Text,
  Avatar: FieldType.Image,
  LinkedInUrl: FieldType.Text,
  Email: FieldType.Text,
  FacebookUrl: FieldType.Text,
  InstagramUrl: FieldType.Text,
  XUrl: FieldType.Text,
};

export const AllContentBlocks = {
  '... on ComponentBlocksActionBlock': {
    ButtonText: FieldType.Text,
    ButtonLink: FieldType.Text,
    ButtonArrow: FieldType.Boolean,
    CTAIntro: FieldType.Blocks,
    CTAFooter: FieldType.Text,
    AsideContent: FieldType.Blocks,
    AsidePosition: FieldType.Text,
    ActionBlockBackground: BackgroundFields,
    ActionBlockDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksImage': {
    Images: FieldType.Image,
    ImageCaption: FieldType.Text,
    CustomHeight: FieldType.Number,
    CustomWidth: FieldType.Number,
    ImageBackground: BackgroundFields,
    ImageDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksText': {
    Body: FieldType.Text,
    Columns: FieldType.Text,
    Offset: FieldType.Text,
    TextBlockBackground: BackgroundFields,
    TextBlockDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksThreeColumnText': {
    ThreeColumnTitle: FieldType.Text,
    LeftContent: FieldType.Text,
    CenterContent: FieldType.Text,
    RightContent: FieldType.Text,
    ShowNumbers: FieldType.Boolean,
    ThreeColumnDescription: FieldType.Blocks,
    ThreeColumnVariant: FieldType.Text,
    LeftImage: FieldType.Image,
    CenterImage: FieldType.Image,
    RightImage: FieldType.Image,
    LeftHeadingFontSize: FieldType.Text,
    LeftBodyFontSize: FieldType.Text,
    RightHeadingFontSize: FieldType.Text,
    RightBodyFontSize: FieldType.Text,
    CenterHeadingFontSize: FieldType.Text,
    CenterBodyFontSize: FieldType.Text,
    ThreeColumnBackground: BackgroundFields,
    ThreeColumnDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksFaqList': {
    Body: FieldType.Text,
    Questions: {
      Question: FieldType.Text,
      Answer: FieldType.Text,
      Group: FieldType.Text,
    },
    Variant: FieldType.Text,
    Columns: FieldType.Text,
    Offset: FieldType.Text,
    FaqListBackground: BackgroundFields,
    FaqListDisplayOptions: DisplayOptions,
    FaqListImage: FieldType.Image,
  },
  '... on ComponentBlocksStepsList': {
    Title: FieldType.Text,
    Steps: {
      Title: FieldType.Text,
      Description: FieldType.Blocks,
      Image: FieldType.Image,
      StepItemCta: {
        ButtonText: FieldType.Text,
        ButtonLink: FieldType.Text,
        ButtonPlaceholder: FieldType.Text,
        ButtonNumberValue: FieldType.Boolean,
        ShowButton: FieldType.Boolean,
      },
    },
    StepsListBackground: BackgroundFields,
    StepsListDisplayOptions: DisplayOptions,
    StepsListStyle: FieldType.Text,
    StepsListBlurb: FieldType.Blocks,
    StepsListShowNumbers: FieldType.Boolean,
  },
  '... on ComponentBlocksCta': {
    Body: FieldType.Text,
    CtaText: FieldType.Text,
    CtaUrl: FieldType.Text,
    FootNote: FieldType.Text,
    CtaBackground: BackgroundFields,
    CtaDisplayOptions: DisplayOptions,
    CTAButtonStyle: FieldType.Text,
    CtaHeroMedia: FieldType.Image,
    CTAHeroMediaDisplay: FieldType.Text,
    CTAAlignment: FieldType.Text,
    HideInnerBackground: FieldType.Boolean,
  },
  '... on ComponentBlocksBreak': {
    Height: FieldType.Text,
  },
  '... on ComponentBlocksPostcard': {
    Title: FieldType.Text,
    Tagline: FieldType.Text,
    Background: FieldType.Image,
    Url: FieldType.Text,
    PostcardBlockBackground: BackgroundFields,
    PostcardDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksHighlightBlock': {
    Text: FieldType.Text,
    BackgroundImage: FieldType.Image,
    QuoteAuthor: FieldType.Text,
    HighlightVariant: FieldType.Text,
    HighlightBackground: BackgroundFields,
    HighlightDisplayOptions: DisplayOptions,
    AlignImageRight: FieldType.Boolean,
  },
  '... on ComponentBlocksHtml': {
    HtmlContent: FieldType.Text,
  },
  '... on ComponentBlocksProsAndConsTable': {
    Title: FieldType.Text,
    LeftColText: FieldType.Text,
    RightColText: FieldType.Text,
    ConList: {
      ConItemTitle: FieldType.Text,
      ConItemLogo: FieldType.Image,
      ConItemDescription: FieldType.Text,
    },
    ProList: {
      ProItemTitle: FieldType.Text,
      ProItemLogo: FieldType.Image,
      ProItemDescription: FieldType.Text,
    },
    ProsAndConsBackground: BackgroundFields,
    ProsAndConsDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksProductFeatures': {
    HeaderText: FieldType.Text,
    Tabs: {
      Title: FieldType.Text,
      Image: FieldType.Image,
      ImageColRight: FieldType.Boolean,
      Body: FieldType.Text,
      ButtonText: FieldType.Text,
      ButtonLink: FieldType.Text,
    },
    ComponentBackgroundColour: FieldType.Text,
    ProductFeaturesBackground: BackgroundFields,
    ProductFeaturesDisplayOptions: DisplayOptions,
    ProductFeaturesImageColumnSize: FieldType.Text,
    ProductFeaturesImageAlignment: FieldType.Text,
    ProductFeaturesTextColumnSize: FieldType.Text,
    ProductFeaturesItemSpacing: FieldType.Text,
    ProductFeaturesRoundImageCorners: FieldType.Boolean,
    ProductFeaturesImageBorder: FieldType.Boolean,
  },
  '... on ComponentBlocksAdditionalFeatures': {
    AdditionalFeature: {
      Header: FieldType.Text,
      SubHeader: FieldType.Text,
      Desc: FieldType.Text,
      Logo: FieldType.Image,
    },
    Title: FieldType.Text,
    AdditionalFeaturesBackground: BackgroundFields,
    AdditionalFeaturesDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksLenderList': {
    NumberOfLenders: FieldType.Text,
    TitleText: FieldType.Text,
    LenderLogos: FieldType.Image,
    LenderListBorderLogos: FieldType.Boolean,
    LenderListBackground: BackgroundFields,
    LenderListDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksFunnel': {
    FunnelLogo: FieldType.Image,
    FunnelHeader: FieldType.Text,
    FunnelSubHeader: FieldType.Text,
    FunnelVariant: FieldType.Text,
    FunnelFootNote: FieldType.Text,
    FunnelContents: FieldType.Blocks,
    FunnelHideInnerBackground: FieldType.Boolean,
    InputLabel: FieldType.Text,
    InputPlaceholder: FieldType.Text,
    InputLink: FieldType.Text,
    FunnelButtonLabel: FieldType.Text,
    FunnelBackground: BackgroundFields,
    FunnelDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksTableWidget': {
    TableTitle: FieldType.Text,
    TableSubContent: FieldType.Text,
    ColumnWidthPreset: FieldType.Text,
    TableHeadings: {
      Label: FieldType.Text,
      Align: FieldType.Text,
      FontSize: FieldType.Text,
    },
    TableRows: {
      Cells: {
        Content: FieldType.Text,
        Align: FieldType.Text,
        VerticalAlign: FieldType.Text,
        FontSize: FieldType.Text,
      },
    },
    TableBackground: BackgroundFields,
    TableDisplayOptions: DisplayOptions,
    TableInnerBackgroundColor: FieldType.Text,
    DisableTableRowHover: FieldType.Boolean,
    DisableTableRowStripe: FieldType.Boolean,
  },
  '... on ComponentBlocksTwoColumnTextImageBlock': {
    TwoColumnBody: FieldType.Text,
    TwoColumnBlurb: FieldType.Blocks,
    Image: FieldType.Image,
    TwoColumnTitle: FieldType.Text,
    ImageColRight: FieldType.Boolean,
    TwoColumnBackground: BackgroundFields,
    TwoColumnDisplayOptions: DisplayOptions,
    ImageColumnSize: FieldType.Text,
    ImageAlignment: FieldType.Text,
    TextColumnSize: FieldType.Text,
    ItemSpacing: FieldType.Text,
    RoundImageCorners: FieldType.Boolean,
    ImageBorder: FieldType.Boolean,
  },
  '... on ComponentBlocksLatestResourcesBlock': {
    Title: FieldType.Text,
    ViewMoreLabel: FieldType.Text,
    MaxResources: FieldType.Number,
    ResourceCategories: {
      CategoryName: FieldType.Text,
      Slug: FieldType.Text,
    },
    LatestResourcesBackground: BackgroundFields,
    LatestResourcesDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksLoanCalculators': {
    CalculatorType: FieldType.Text,
    CalculatorBackground: BackgroundFields,
    CalculatorDisplayOptions: DisplayOptions,
    CustomCalculatorTitle: FieldType.Text,
    CalculatorBlurb: FieldType.Blocks,
    CustomInputsTitle: FieldType.Text,
    CustomOutputsTitle: FieldType.Text,
  },
  '... on ComponentBlocksCalculatorGrid': {
    CalculatorTitle: FieldType.Text,
    Rows: FieldType.Number,
    Column: FieldType.Number,
    Calculators: {
      name: FieldType.Text,
      formula: FieldType.Text,
      input_fields: FieldType.JSON,
      display_order: FieldType.Number,
      description: FieldType.Text,
    },
  },
  '... on ComponentBlocksThreeSteps': {
    ThreeStepTitle: FieldType.Text,
    ThreeStepDescription: FieldType.Text,
    ThreeStepBlurb: FieldType.Blocks,
    Steps: {
      Title: FieldType.Text,
      Description: FieldType.Text,
      Image: FieldType.Image,
      StepItemCta: {
        ButtonText: FieldType.Text,
        ButtonLink: FieldType.Text,
        ButtonPlaceholder: FieldType.Text,
        ButtonNumberValue: FieldType.Boolean,
        ShowButton: FieldType.Boolean,
      },
    },
    BlockCta: {
      ButtonText: FieldType.Text,
      ButtonLink: FieldType.Text,
      ButtonPlaceholder: FieldType.Text,
      ButtonNumberValue: FieldType.Boolean,
      ShowButton: FieldType.Boolean,
    },
    CTAIntro: FieldType.Blocks,
    CTAFooter: FieldType.Text,
    StepImageBackground: FieldType.Boolean,
    ShowNumbers: FieldType.Boolean,
    HideArrows: FieldType.Boolean,
    ThreeStepsDisplayOptions: DisplayOptions,
    ThreeStepsBackground: BackgroundFields,
  },
  '... on ComponentBlocksProsAndConsTableV2': {
    ProsAndConsTitle: FieldType.Text,
    TableRows: {
      FinanceType: FieldType.Text,
      Con: {
        ConItemDescription: FieldType.Text,
        ConItemTitle: FieldType.Text,
        ConItemLogo: FieldType.Image,
      },
      Pros: {
        ProItemTitle: FieldType.Text,
        ProItemLogo: FieldType.Image,
        ProItemDescription: FieldType.Text,
      },
    },
  },
  '... on ComponentBlocksRelatedArticles': {
    ShowLatestByDefault: FieldType.Boolean,
    Pages: {
      Title: FieldType.Text,
      Slug: FieldType.Text,
      publishedAt: FieldType.Text,
      Blocks: {
        '... on ComponentBlocksAuthorDetails': {
          WrittenBy: {
            Name: FieldType.Text,
            Role: FieldType.Text,
          },
        },
      },
      seo: SeoType,
      PageHero: {
        HeroMedia: FieldType.Image,
        HeroBackgroundImage: FieldType.Image,
        HeroText: FieldType.Text,
      },
    },
    RelatedArticlesDisplayOptions: DisplayOptions,
    RelatedArticlesBackground: BackgroundFields,
  },
  '... on ComponentBlocksMetricHighlight': {
    MetricHighlightTitle: FieldType.Text,
    MetricHighlightInfo: {
      MetricInfo: FieldType.Text,
      MetricDescription: FieldType.Text,
    },
    MetricHighlightDisplayOptions: DisplayOptions,
    MetricHighlightBackground: BackgroundFields,
  },
  '... on ComponentBlocksPageSeparator': {
    SeparatorTitle: FieldType.Text,
    SeparatorDescription: FieldType.Text,
    SeparatorBlurb: FieldType.Blocks,
    UpdatedDate: FieldType.Text,
    ReviewedBy: {
      Name: FieldType.Text,
      Avatar: FieldType.Image,
    },
    WrittenBy: {
      Name: FieldType.Text,
      Avatar: FieldType.Image,
    },
    PageSeparatorBackground: BackgroundFields,
    PageSeparatorDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksInfoTilesBlock': {
    InfoTilesIntro: FieldType.Blocks,
    TileRows: {
      RowColumns: FieldType.Text,
      Tiles: {
        TileSize: FieldType.Text,
        TileMedia: FieldType.Image,
        TileContents: FieldType.Blocks,
      },
    },
    InfoTilesBackground: BackgroundFields,
    InfoTilesDisplayOptions: DisplayOptions,
  },
  '... on ComponentCalculatorCalculatorHighlight': {
    CalcHighlightTitle: FieldType.Text,
    CalcHighlightBlurb: FieldType.Blocks,
    LoanCalculator: {
      CalculatorTitle: FieldType.Text,
      CalculatorType: FieldType.Text,
      CalculatorDescription: FieldType.Blocks,
      CustomCalculatorCTA: FieldType.Text,
      CalculatorCategory: {
        name: FieldType.Text,
        slug: FieldType.Text,
        CategoryIcon: FieldType.Image,
      },
      CalculatorPage: {
        Slug: FieldType.Text,
      },
    },
    HightlightCalculator: {
      CalculatorTitle: FieldType.Text,
      CalculatorType: FieldType.Text,
      CalculatorDescription: FieldType.Blocks,
      CustomCalculatorCTA: FieldType.Text,
      CalculatorPage: {
        Slug: FieldType.Text,
      },
      CalculatorCategory: {
        name: FieldType.Text,
        slug: FieldType.Text,
        CategoryIcon: FieldType.Image,
      },
    },
    CalculatorHighlightBackground: BackgroundFields,
    CalculatorHighlightDisplayOptions: DisplayOptions,
  },
  '... on ComponentLoanLoanComparison': {
    LoanComparisonTitle: FieldType.Text,
    Description: FieldType.Text,
    DefaultLoanAmount: FieldType.Number,
    DefaultSort: FieldType.Text,
    DefaultView: FieldType.Text,
    DefaultPurpose: FieldType.Text,
    DefaultProductType: FieldType.Text,
    IncludeLenderTiers: FieldType.Boolean,
    Lenders: {
      lenderRef: FieldType.Text,
      lenderName: FieldType.Text,
      lenderLogo: FieldType.Text,
      minLoanAmount: FieldType.Number,
      maxLoanAmount: FieldType.Number,
      minLoanTerm: FieldType.Number,
      maxLoanTerm: FieldType.Number,
      minTimeInBiz: FieldType.Number,
      maxTimeInBiz: FieldType.Number,
      minMonthlySales: FieldType.Number,
      maxMonthlySales: FieldType.Number,
      minApr: FieldType.Number,
      maxApr: FieldType.Number,
      overrideApr: FieldType.Boolean,
      overrideMinApr: FieldType.Number,
      overrideMaxApr: FieldType.Number,
      hideApr: FieldType.Boolean,
      purposeAllowed: FieldType.JSON,
      lenderTiers: {
        tierName: FieldType.Text,
        minLoanAmount: FieldType.Number,
        maxLoanAmount: FieldType.Number,
        minLoanTerm: FieldType.Number,
        maxLoanTerm: FieldType.Number,
        minTimeInBiz: FieldType.Number,
        maxTimeInBiz: FieldType.Number,
        minMonthlySales: FieldType.Number,
        maxMonthlySales: FieldType.Number,
        minApr: FieldType.Number,
        maxApr: FieldType.Number,
        overrideApr: FieldType.Boolean,
        overrideMinApr: FieldType.Number,
        overrideMaxApr: FieldType.Number,
        hideApr: FieldType.Boolean,
        purposeAllowed: FieldType.JSON,
        productTypesAllowed: FieldType.JSON,
      },
    },
    LoanComparisonBackground: BackgroundFields,
    LoanComparisonDisplayOptions: DisplayOptions,
  },
  '... on ComponentLoanLoanHighlight': {
    LoanHighlightTitle: FieldType.Text,
    LoanHighlightDescription: FieldType.Text,
    HighlightDefaultLoanAmount: FieldType.Number,
    HighlightDefaultPurpose: FieldType.Text,
    HighlightDefaultProductType: FieldType.Text,
    LenderTiers: {
      minApr: FieldType.Number,
      maxApr: FieldType.Number,
      hideApr: FieldType.Boolean,
      overrideApr: FieldType.Boolean,
      overrideMinApr: FieldType.Number,
      overrideMaxApr: FieldType.Number,
      lender: {
        lenderName: FieldType.Text,
        lenderLogo: FieldType.Text,
        hideApr: FieldType.Boolean,
      },
    },
    LoanHighlightBackground: BackgroundFields,
    LoanHighlightDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksAuthorDetails': {
    WrittenBy: {
      Name: FieldType.Text,
      Avatar: FieldType.Image,
      Role: FieldType.Text,
      Bio: FieldType.Text,
      LinkedInUrl: FieldType.Text,
      Email: FieldType.Text,
      FacebookUrl: FieldType.Text,
      InstagramUrl: FieldType.Text,
      XUrl: FieldType.Text,
      createdAt: FieldType.Text,
      updatedAt: FieldType.Text,
      publishedAt: FieldType.Text,
    },
    ReviewedBy: {
      Name: FieldType.Text,
      Avatar: FieldType.Image,
      Role: FieldType.Text,
      Bio: FieldType.Text,
      LinkedInUrl: FieldType.Text,
      Email: FieldType.Text,
      FacebookUrl: FieldType.Text,
      InstagramUrl: FieldType.Text,
      XUrl: FieldType.Text,
      createdAt: FieldType.Text,
      updatedAt: FieldType.Text,
      publishedAt: FieldType.Text,
    },
    ShowWrittenByLabel: FieldType.Boolean,
    ShowReviewedByLabel: FieldType.Boolean,
    ShowBio: FieldType.Boolean,
    ShowSocialLabels: FieldType.Boolean,
    WrittenByOverride: FieldType.Text,
    ReviewedByOverride: FieldType.Text,
    AuthorSectionDetails: FieldType.Text,
    AuthorSectionStat: FieldType.Text,
    AuthorDetailsBackground: BackgroundFields,
    AuthorDetailsDisplayOptions: DisplayOptions,
  },
  '... on ComponentBlocksPlatformReviewsBlock': {
    ReviewType: FieldType.Text,
    ReviewsIntro: FieldType.Blocks,
    ReviewsBackground: BackgroundFields,
    ReviewsDisplayOptions: DisplayOptions,
  },
};
